module.exports = __webpack_public_path__ + "static/img/banner-8.2a0f202c.png";